<template>
  <div>
    <div :class="{'sticky-top': edit}">
      <div class="card m-b-0">
        <div class="card-body text-right m-r-30">
          <span v-if="edit">
            <a href @click.prevent="deleteAuthor()" class="btn btn-warning m-r-10">
              <i class="fa fa-trash"></i>
              Supprimer
            </a>
            <a href @click.prevent="saveAuthor()" class="btn btn-primary m-r-10">
              <i class="fa fa-save"></i>
              Enregistrer
            </a>
            <a href @click.prevent="setEdit(false)" class="btn btn-outline m-r-10">
              <i class="fa fa-times"></i>
            </a>
          </span>
          <span v-else>
            <a href @click.prevent="setEdit(true)" class="btn btn-outline m-r-10">
              <i class="fa fa-pencil"></i>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid">
        <transition name="fade" mode="out-in">
          <div v-loading="loading">
            <div class="row">
              <div class="col-md-8">
                <div v-if="!edit" class="card">
                  <div class="card-header">
                    <h4>{{ storiesPagination.total }} Contributions</h4>
                  </div>
                  <div class="card-header">
                    <stories
                      :stories="stories"
                      :pagination="storiesPagination"
                      :toStory="toStory"
                      :setPage="setPage"></stories>
                  </div>
                </div>
                <div v-if="edit" class="card">
                  <div class="card-header">
                    <h4>Modifier le profil</h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <el-form label-position="right" size="medium" label-width="100px">
                          <el-form-item label="Statut">
                            <el-select
                              @change="updateAuthorAttribute('status', $event)"
                              :value="author.status">
                              <el-option
                                v-for="item in constants.AUTHOR_STATUSES"
                                :label="$t(`author.${item}`)"
                                :key="item"
                                :value="item">
                                  {{ $t(`author.${item}`) }}
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="Prénom">
                            <el-input
                              @input="updateAuthorAttribute('firstname', $event)"
                              :value="author.firstname"></el-input>
                          </el-form-item>
                          <el-form-item label="Nom">
                            <el-input
                              @input="updateAuthorAttribute('lastname', $event)"
                              :value="author.lastname"></el-input>
                          </el-form-item>
                          <el-form-item label="Alias">
                            <el-input
                              @input="updateAuthorAttribute('alias', $event)"
                              :value="author.alias"></el-input>
                          </el-form-item>
                          <el-form-item label="Email">
                            <el-input
                              @input="updateAuthorAttribute('email', $event)"
                              :value="author.email"></el-input>
                          </el-form-item>
                          <el-form-item label="Présentation">
                            <el-input
                              type="textarea"
                              :autosize="{ minRows: 2, maxRows: 10}"
                              @input="updateAuthorAttribute('description', $event)"
                              :value="author.description"></el-input>
                          </el-form-item>
                          <el-form-item label="Citation">
                            <el-input
                              type="textarea"
                              :rows="3"
                              :autosize="{ minRows: 2, maxRows: 10}"
                              @input="updateAuthorAttribute('quote', $event)"
                              :value="author.quote"></el-input>
                          </el-form-item>
                          <el-form-item>
                            <span slot="label">
                              Slug <i class="fa fa-lock"></i>
                            </span>
                            <el-input
                              readonly
                              :value="author.slug"></el-input>
                          </el-form-item>
                          <h4>Réseaux sociaux</h4>
                          <p class="text-muted">
                            Veuillez renseigner l’URL complète du service
                            (exemple : https://twitter.com/LeMediaTV).
                          </p>
                          <el-form-item
                            v-if="author.id"
                            v-for="social in constants.AUTHOR_SOCIAL_NETWORKS"
                            :key="social"
                            :label="social">
                            <el-input
                              :name="social"
                              v-model="socialNetworks[social]"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card card-user">
                  <div class="card-image"><div>
                    <img src="/static/img/le-media-logo-studio.jpg" alt="...">
                  </div>
                </div>
                <div class="card-body">
                  <div>
                    <div class="author">
                      <img :src="author.thumb_author_url" alt="..." class="avatar border-gray">
                      <h4 class="title" :class="{'text-muted': !author.screenname}">
                        {{ author.screenname || 'John Doe' }}
                        <br>
                      </h4>
                    </div>
                    <div
                      v-if="edit"
                      class="text-center m-b-20">
                      <el-upload
                        :show-file-list="false"
                        :action="`authors/${$route.params.id}/upload-photo/` | api_url"
                        :http-request="uploadPhoto">
                        <el-button size="small" type="primary">
                          <i class="fa fa-upload"></i>
                          Choisir une photo
                        </el-button>
                      </el-upload>
                    </div>
                    <p v-if="author.description && !edit" class="description text-center">
                      <span>
                        {{ author.description }}
                      </span>
                    </p>
                  </div>
                  <hr>
                  <div class="text-center">
                    <div v-if="author.id">
                      <a :href="url"
                        v-if="url"
                        v-for="(url, social) in author.social_networks"
                        class="btn btn-simple btn-link btn-icon">
                        <i :class="`fa fa-${social}`"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
            <!-- <pre>{{ constants }}</pre> -->
            <!-- <pre>{{ socialNetworks }}</pre> -->
            <!-- <pre>{{ author }}</pre> -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    constants: 'constants',
    author: 'author',
    stories: 'stories',
    storiesPagination: 'storiesPagination'
  }),
  components: {},
  data () {
    return {
      loading: true,
      edit: false,
      mask: 'id,status,screenname,firstname,lastname,alias,slug,quote,' +
      'email,social_networks,photo_credits,description,created_at,updated_at,' +
      'photo,photo_url,thumb_author_url,thumb_author_story_url,thumb_caroussel_md_url',
      storiesMask: 'id,slug,title,status,thumb_story_list_url,scheme,created_at,' +
      'published_at,authors{id,screenname}' +
      'tags{id,scheme,label}',
      storiesFilters: {
        author_id: this.$route.params.id,
        page: 1,
        per_page: 6,
      },
      socialNetworks: {}
    }
  },
  watch: {
    '$route' (to, from) {
      this.edit = to.query.edit
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.$route.query.edit) {
        this.edit = this.$route.query.edit
      }
      this.$store.dispatch('getConstants', {
        params: {
          'keys': 'AUTHOR_STATUSES,AUTHOR_SOCIAL_NETWORKS',
        }
      })
      this.$store.dispatch('getAuthor', {
        id: this.$route.params.id,
        headers: {
          'X-Fields': this.mask
        }
      }).then(() => {
        this.loading = false
        this.socialNetworks = Object.assign({}, this.author.social_networks)
        this.updateAuthorAttribute(
          'thumb_author_url',
          this.author.thumb_author_url + '?d=' + (new Date()))
      })
      this.$store.dispatch('getStories', {
        params: this.storiesFilters,
        headers: { 'x-fields': this.storiesMask }
      })
    },
    saveAuthor () {
      this.loading = true
      this.updateAuthorAttribute('social_networks', this.socialNetworks)
      this.$store.dispatch('saveAuthor', {
        headers: {
          'X-Fields': this.mask,
          'X-UpdateKeys': 'status,email,firstname,lastname,alias,description,quote,social_networks,created_at'
        }
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Auteur enregistré avec succès'
        })
        this.loading = false
      })
    },
    deleteAuthor () {
      this.$confirm('Ceci effacera l’auteur. Continuer ?', 'Warning', {
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('deleteAuthor', {
          id: this.$route.params.id,
          headers: {
            'X-Fields': this.mask,
          }
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Auteur supprimé'
          })
          this.$router.replace({
            name: 'authors'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Suppression annulée'
        })
      })
    },
    updateAuthorAttribute(key, value) {
      let data = {
        [key]: value
      }
      this.$store.commit('UPDATE_AUTHOR_VALUE', data)
    },
    toStory (storyId) {
      this.$router.push({
        name: 'story',
        params: {id: storyId}
      })
    },
    setPage (page) {
      window.scrollTo(0,0)
    },
    setEdit (edit) {
      this.$router.push({
        name: 'author',
        params: {id: this.$route.params.id},
        query: {edit: edit}
      })
    },
    uploadPhoto (option) {
      const formData = new FormData()
      formData.append('image', option.file)
      this.$store.dispatch('uploadAuthorPhoto', {
        formEncodedData: formData,
        id:this.$route.params.id,
        headers: {
          'X-Fields': this.mask,
        }
      }).then(() => {
        this.updateAuthorAttribute(
          'thumb_author_url',
          this.author.thumb_author_url + '?d=' + (new Date()))
      })
    }
  }
}
</script>
<style>

.el-select {
  width: 100%;
}


</style>
